import { SvgIcon } from "@mui/material"

import { ReactComponent as NewIcon } from "./new.svg"

export const StatusNewIcon = (props) => {
    return (
        <SvgIcon component={NewIcon} {...props} inheritViewBox id="status-new-icon" />
    )
}